import "./Header.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slice/authSlice";
import { LogOut } from "lucide-react";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();  // 👈 to know current path
  const dispatch = useDispatch();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="navbar">
      <h1
        className="logo"
        style={{ cursor: "pointer" }}
        onClick={() => handleNavigation("/dashboard")}
      >
        Stockasti<span style={{ color: "var(--green)" }}>x</span>
      </h1>

      <div className="links">
        <button
          className={`ic2 ${location.pathname === "/compare" ? "active" : ""}`}
          onClick={() => navigate("/compare")}
        >
          Compare &#8599;
        </button>

        <div
          className={location.pathname === "/discover" ? "active" : ""}
          onClick={() => handleNavigation("/discover")}
        >
          Discover
        </div>

        <div
          className={location.pathname === "/economicanalysis" ? "active" : ""}
          onClick={() => handleNavigation("/economicanalysis")}
        >
          Economic Analysis
        </div>

        <div
          className={location.pathname === "/watchlist" ? "active" : ""}
          onClick={() => handleNavigation("/watchlist")}
        >
          Watchlist
        </div>

        <div
          className={location.pathname === "/workbench" ? "active" : ""}
          onClick={() => handleNavigation("/workbench")}
        >
          Workbench
        </div>

        <div
          className={location.pathname === "/technicalanalysis" ? "active" : ""}
          onClick={() => handleNavigation("/technicalanalysis")}
        >
          Technical Analysis
        </div>

        <div onClick={handleLogout}>
          <LogOut />
        </div>
      </div>
    </div>
  );
}

export default Header;
